
import { Button } from "@/components/ui/button";

interface EmptyServicesListProps {
  onAddService: () => void;
}

export function EmptyServicesList({ onAddService }: EmptyServicesListProps) {
  return (
    <div className="flex flex-col items-center justify-center py-10">
      <p className="text-muted-foreground mb-4">No services added yet.</p>
      <Button onClick={onAddService}>Add your first service</Button>
    </div>
  );
}
